import { primeRelationsCache } from '../hooks/useRelations';
import { setRelationDirections, setRelations } from '../redux/actions';
import store from '../redux/store';
import { fetch_request } from './request';

let inflight = null;

const normaliseDirections = (payload) => {
  if (!payload) return [];
  if (Array.isArray(payload)) return payload;
  if (Array.isArray(payload.list)) return payload.list;
  return [];
};

export const enrichDirections = (directions = [], relations = []) => {
  const map = new Map();
  relations.forEach((rel) => {
    if (rel?.id) map.set(rel.id, rel);
  });
  return directions.map((dir) => {
    const fromId = dir?.from_relation?.id || dir?.from_relation_id || null;
    const toId = dir?.to_relation?.id || dir?.to_relation_id || null;
    const fromRel = dir?.from_relation || (fromId ? map.get(fromId) : null);
    const toRel = dir?.to_relation || (toId ? map.get(toId) : null);
    return {
      ...dir,
      from_relation: fromRel || (fromId ? { id: fromId } : null),
      to_relation: toRel || (toId ? { id: toId } : null),
      from_relation_id: fromId,
      to_relation_id: toId,
    };
  });
};

export const ensureRelationsLoaded = async () => {
  const state = store.getState();
  const hasRelations = Array.isArray(state?.grave?.relations) && state.grave.relations.length > 0;
  const hasDirections =
    Array.isArray(state?.grave?.relationDirections) && state.grave.relationDirections.length > 0;

  if (hasRelations && hasDirections) {
    return {
      relations: state.grave.relations,
      relationDirections: state.grave.relationDirections,
    };
  }

  if (inflight) return inflight;

  inflight = (async () => {
    const [relationsRes, directionsRes] = await Promise.all([
      fetch_request('/api/relations', { cacheKey: '/api/relations' }).then((r) => r.json()),
      fetch_request('/api/relation_directions', { cacheKey: '/api/relation_directions' }).then(
        (r) => r.json(),
      ),
    ]);

    const relations = Array.isArray(relationsRes) ? relationsRes : [];
    const directions = enrichDirections(normaliseDirections(directionsRes), relations);

    store.dispatch(setRelations(relations));
    primeRelationsCache(relations);
    store.dispatch(setRelationDirections(directions));

    return { relations, relationDirections: directions };
  })();

  try {
    const result = await inflight;
    return result;
  } finally {
    inflight = null;
  }
};

export default ensureRelationsLoaded;
